"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Medallia = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "Medallia", { enumerable: true, get: function () { return features_1.Medallia; } });
//# sourceMappingURL=index.js.map